import { createSelector } from "reselect";

const getKycDetails = (state: any) => state.getIn(["panDetailsReducer", "kycDetails"]);
const getFetchKycDetailsErrors = (state: any) => state.getIn(["panDetailsReducer", "fetchKycDetailsError"]);

const panDetailsSelector = createSelector(
  [getKycDetails,getFetchKycDetailsErrors],
  (
    kycDetails,
    fetchKycDetailsError,
   
  ) => ({
    kycDetails,
    fetchKycDetailsError,
  

  })
);
export default panDetailsSelector;